<template>
  <div class="basicInfo">
    <el-row class="flow-wrap" :gutter="25">
      <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
        <p>
          真实姓名：<span>{{ userInfoObj.realName || "未实名" }}</span>
        </p>
      </el-col>

      <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
        <p>
          手机号码：<span>{{ userInfoObj.phoneNumber }}</span>
        </p>
      </el-col>

      <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
        <p>
          注册时间：<span>{{ userInfoObj.createTime }}</span>
        </p>
      </el-col>
    </el-row>
    <p class="commonTitle">储蓄卡</p>
    <common-table :data="saveData" :isShow="false">
      <el-table-column
        prop="cardNo"
        min-width="200"
        show-overflow-tooltip
        label="银行卡卡号"
      >
        <template slot-scope="scope">
          {{ scope.row.cardNo }}
        </template>
      </el-table-column>
      <el-table-column
        prop="bankName"
        label="所属银行"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="持卡人姓名"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="idCard"
        label="持卡人身份证号"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="银行预留手机号"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
        label="添加时间"
      ></el-table-column>
      <!-- 特判 -->
      <el-table-column
      
        label="操作"
        min-width="100"
        fixed="right"
        
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="openAddDialog(scope.row)"
            >修改
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <!-- 新增 -->
    <form-dialog
      ref="formDialog"
      :formDialogTitle="'修改'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="120px"
      dialogWidth="460px"
    >
      <el-form-item label-width="135px" label="持卡人姓名" prop="userName">
        <el-input
          type="text"
          maxlength="100"
          v-model="dialogModel.userName"
          placeholder="请输入"
          style="width: 250px"
        ></el-input>
      </el-form-item>
         <el-form-item label-width="135px" label="持卡人身份证号" prop="idCard">
        <el-input
          type="text"
          maxlength="100"
          v-model="dialogModel.idCard"
          placeholder="请输入"
          style="width: 250px"
        ></el-input>
      </el-form-item>
            <el-form-item label-width="135px" label="预留手机号" prop="phone">
        <el-input
          type="text"
          maxlength="100"
          v-model="dialogModel.phone"
          placeholder="请输入"
          style="width: 250px"
        ></el-input>
      </el-form-item>
            <el-form-item label-width="135px" label="银行卡卡号" prop="cardNo">
        <el-input
          type="text"
          maxlength="100"
          v-model="dialogModel.cardNo"
          placeholder="请输入"
          style="width: 250px"
        ></el-input>
      </el-form-item>
      <!-- 银行名称 -->
          <el-form-item label="银行名称">
        <el-select v-model="dialogModel.bankAbbr" @change="handleSelectChange" >
          <el-option
            v-for="item in bankList"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import FormDialog from "../../dialog/FormDialog";
import privateKey from "service/constant/privateKey";
import MemberService from "service/MemberService";
import ShowInfoDialog from "@/view/dialog/ShowInfoDialog";
import CommonTable from "components/common/CommonTable";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "BasicInfo",
  data() {
    return {
      userInfoObj: {},
      parentInfoArr: [],
      personList: [],
      saveData: [],
      bankList: [],
      seat: "",
      dialogModel: {
          cardNo: '',
          userName: '',
          idCard: '',
          phone: '',
          bankAbbr: '',
          bankName: ''
      },
      dialogRules: {
          cardNo:[
               {
            required: true,
            message: "请输入",
          },
          ],
           userName:[
               {
            required: true,
            message: "请输入",
          },
          ],
           idCard:[
               {
            required: true,
            message: "请输入",
          },
          ],
           phone:[
               {
            required: true,
            message: "请输入",
          },
          ],
      }
    };
  },
  mixins: [loadMixin, dialogMixin],
  mounted() {
      
    this.getDetail();
    this.getCredit();
    // 新增银行
     this.getTypeNames("银行名称", (res) => {
      this.bankList = [ ...res];
    });
  },
  components: { ShowInfoDialog, CommonTable,FormDialog },
  computed: {
    isAgent() {
      return this.userInfo.roleId == 7;
    },
    dialogService() {
        return MemberService.editData
    },
    
    ...mapGetters(["serverType", "tatId", "userInfo"]),
  },
  methods: {
        handleSelectChange(value) {
          this.bankList.forEach(item => {
            if(item.dictKey == value) {
              this.dialogModel.bankName = item.dictValue
            }
          })
          console.log(this.dialogModel,'w')
        // 根据选中的 value（即 dictKey），查找对应的 dictValue
        // const selectedDictValue = this.bankList.find(item => item.dictKey === value)?.dictValue
        
        // // 输出选中的 dictKey 和 dictValue
        // console.log('Selected dictKey:', value);
        // console.log('Selected dictValue:', selectedDictValue);
    },
      openAddDialog(item, flag) {
    console.log(item)
  
      this.dialogModel = JSON.parse(JSON.stringify(item));
      this.$refs.formDialog.open();
    },
    getCredit() {
      const params = {
        userId: this.$route.params.id,
      };

      this.doLoad(
        MemberService.PrivateGetLogList,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.saveData = result;
          });
        },
        "信息获取失败"
      );
    },
      dialogClose() {
      this.dialogModel = {
         cardNo: '',
          userName: '',
          idCard: '',
          phone: ''
      };
     
    },
      dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    getDetail() {
      const params = {
        userId: this.$route.params.id,
      };

      this.doLoad(
        MemberService.getMemInfoByUserId,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            this.userInfoObj = res.contents.tPrivateMemInfo;
          });
        },
        "信息获取失败"
      );
    },
  },
};
</script>

<style scoped>
.basicInfo p {
  font-size: 14px;
  color: #000;
  font-weight: bold;
  margin-bottom: 30px;
}

.basicInfo p span {
  font-weight: normal;
}

.basicInfo p span.blue {
  color: rgba(7, 154, 222, 1);
}

.button-size {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/fragment/personalManage/BasicInfo.vue